import { cx } from '@/libs/cva'

import { DataTableRoot, type DataTableRootProps } from './data-table-root'
import { NoRecords, type NoResultsProps } from './empty-table'
import { TableSkeleton } from './table-skeleton'

interface DataTableProps<TData>
	extends Omit<DataTableRootProps<TData>, 'noResults'> {
	isLoading?: boolean
	queryObject?: Record<string, any>
	noRecords?: Pick<NoResultsProps, 'title' | 'message'>
}

export function DataTable<TData>({
	table,
	columns,
	// prefix,
	// queryObject = {},
	isLoading = false,
	noHeader = false,
	layout = 'fit',
	onRowClick,
	noRecords: noRecordsProps = {},
}: DataTableProps<TData>) {
	if (isLoading) {
		return (
			<TableSkeleton
				layout={layout}
				// rowCount={table.getState().pagination.pageSize ?? 10}
				rowCount={10}
				// search={!!search}
				// filters={!!filters?.length}
				// orderBy={!!orderBy?.length}
				pagination
			/>
		)
	}

	// const noResults = !isLoading && count === 0 && !noQuery
	// const noRecords = !isLoading && count === 0 && noQuery
	const noResults = !isLoading && table.getRowModel().rows.length === 0
	const noRecords = !isLoading && table.getRowModel().rows.length === 0

	if (noRecords) {
		return (
			<NoRecords
				className={cx({
					'flex h-full flex-col overflow-hidden': layout === 'fill',
				})}
				{...noRecordsProps}
			/>
		)
	}

	return (
		<div
			className={cx('divide-y', {
				'flex h-full flex-col overflow-hidden': layout === 'fill',
			})}
		>
			{/* <MemoizedDataTableQuery
        search={search}
        orderBy={orderBy}
        filters={filters}
        prefix={prefix}
      /> */}
			<DataTableRoot
				table={table}
				// count={count}
				columns={columns}
				pagination
				// navigateTo={navigateTo}
				// commands={commands}
				onRowClick={onRowClick}
				noResults={noResults}
				noHeader={noHeader}
				layout={layout}
			/>
		</div>
	)
}
